import Icon from "@Components/generic/icon";
import { Typography } from "@mui/material";

const RadialItem = (props: {
    icon: any,
    text: string
    colour?: string,
  }) => {
    return (
      <>
        <Icon icon={props.icon} sx={{ fontSize: '35px', opacity: 0.7, color: props.colour }} />
        <Typography sx={{ color: props.colour }}>{props.text}</Typography>
      </>
    )
  };

export default RadialItem;